import { subDays } from 'date-fns'
import keyBy from 'lodash-es/keyBy'
import mapValues from 'lodash-es/mapValues'

import { BIRDVIEW_TILE_DELTA_TONE } from '../../DashboardBirdview.constants'
import { BIRDVIEW_CHART_DEFAULT_PERIOD } from '../../DashboardBirdview.constants.controls'
import { getBirdviewChartPeriodDays } from '../../DashboardBirdview.utils.charts'

function checkHasBirdviewKpiLeftOut(breakdown) {
  return breakdown !== null && breakdown.no_due_date + breakdown.rejected > 0
}

function toBirdviewKpiLeftOut(breakdown) {
  return checkHasBirdviewKpiLeftOut(breakdown)
    ? { noDueDate: breakdown.no_due_date, rejected: breakdown.rejected }
    : null
}

// Each point covers a full period ending on its date, the last one today.
function toBirdviewKpiPoints({ days, spark }) {
  const now = new Date()
  const lastIndex = spark.length - 1

  return spark.map((value, index) => ({
    date: subDays(
      now,
      Math.round(((lastIndex - index) * days) / lastIndex)
    ).toISOString(),
    value,
  }))
}

export function toBirdviewKpis(data) {
  const days = getBirdviewChartPeriodDays(data.period)

  return mapValues(keyBy(data.items, 'key'), tile => ({
    delta: tile.delta,
    leftOut: toBirdviewKpiLeftOut(tile.breakdown),
    points: toBirdviewKpiPoints({ days, spark: tile.spark }),
    tone: BIRDVIEW_TILE_DELTA_TONE[tile.delta_tone],
    value: tile.value,
  }))
}

export function toBirdviewKpiFixtures(kpis) {
  return mapValues(kpis, kpi => ({
    ...kpi,
    points: toBirdviewKpiPoints({
      days: BIRDVIEW_CHART_DEFAULT_PERIOD.days,
      spark: kpi.spark,
    }),
  }))
}
